// extracted by mini-css-extract-plugin
module.exports = {"bodySection":"styles-module--bodySection--3nauf","faq":"styles-module--faq--2AAr9","item":"styles-module--item--1T7S5"};